<template>
	<my-dialog ref="settlementDialog" :visible.sync="showDialog" title="商品销售结算" dialog-type="form" :close-on-click-modal="false" width="80%" @close="closeDialog">
		<div class="main_bg">
			<div class="item_info">
				<el-descriptions class="margin-top" title="顾客信息" :column="6" border>
					<template #extra>
						<el-button type="primary" size="small" icon="el-icon-search" @click="showSelectCustomerDialog">选择顾客</el-button>
					</template>
					<el-descriptions-item label="顾客姓名">{{ transformEmpty(customerInfo.name) }}</el-descriptions-item>
					<el-descriptions-item label="性别">{{ transformGender(customerInfo.gender) }}</el-descriptions-item>
					<el-descriptions-item label="年龄">{{ transformEmpty(customerInfo.age) }}</el-descriptions-item>
					<el-descriptions-item label="顾客电话">{{ transformEmpty(customerInfo.phone) }}</el-descriptions-item>
					<el-descriptions-item label="所属门店" span="3">{{ transformEmpty(customerInfo.belongStoreName) }}</el-descriptions-item>
					<el-descriptions-item label="(右眼)球镜">{{ transformEmpty(customerInfo.rParams.qiuJing) }}</el-descriptions-item>
					<el-descriptions-item label="柱镜">{{ transformEmpty(customerInfo.rParams.zhuJing) }}</el-descriptions-item>
					<el-descriptions-item label="轴位">{{ transformEmpty(customerInfo.rParams.zhouWei) }}</el-descriptions-item>
					<el-descriptions-item label="矫正视力">{{ transformEmpty(customerInfo.rParams.jiaoZhengShiLi) }}</el-descriptions-item>
					<el-descriptions-item label="瞳距">{{ transformEmpty(customerInfo.rParams.tongJu) }}</el-descriptions-item>
					<el-descriptions-item label="瞳高">{{ transformEmpty(customerInfo.rParams.tongGao) }}</el-descriptions-item>
					<el-descriptions-item label="(左眼)球镜">{{ transformEmpty(customerInfo.lParams.qiuJing) }}</el-descriptions-item>
					<el-descriptions-item label="柱镜">{{ transformEmpty(customerInfo.lParams.zhuJing) }}</el-descriptions-item>
					<el-descriptions-item label="轴位">{{ transformEmpty(customerInfo.lParams.zhouWei) }}</el-descriptions-item>
					<el-descriptions-item label="矫正视力">{{ transformEmpty(customerInfo.lParams.jiaoZhengShiLi) }}</el-descriptions-item>
					<el-descriptions-item label="瞳距">{{ transformEmpty(customerInfo.lParams.tongJu) }}</el-descriptions-item>
					<el-descriptions-item label="瞳高">{{ transformEmpty(customerInfo.lParams.tongGao) }}</el-descriptions-item>
				</el-descriptions>
			</div>
			<div v-if="vipInfo.keyId" class="item_info border_Green">
				<el-descriptions class="margin-top" title="会员信息" :column="3" border>
					<el-descriptions-item label="会员卡号">{{ vipInfo.vipNo }}</el-descriptions-item>
					<el-descriptions-item label="会员类型">{{ customerInfo.customerTypeStr }}</el-descriptions-item>
					<el-descriptions-item label="会员卡余额"><span style="width: 100px; display: inline-block; color: red; font-weight: bold; font-size: 16px">{{ vipInfo.balance }}</span></el-descriptions-item>
				</el-descriptions>
			</div>
			<div class="item_info border_Warningcolor">
				<el-descriptions class="margin-top" title="订单信息" :column="3" border>
					<template #extra></template>
					<el-descriptions-item label="所属门店">
						<el-select v-model="saleInfo.storeKeyId" placeholder="请选择所属门店" filterable size="small" style="width: 100%" @change="handleSelectStore">
							<el-option v-for="item in storeList" :key="item.keyId" :label="item.name" :value="item.keyId" />
						</el-select>
					</el-descriptions-item>
					<el-descriptions-item label="订单来源">
						<el-select v-model.number="saleInfo.orderSource" placeholder="请选择订单来源" clearable filterable size="small" style="width: 100%" @change="handleSelectOrderSource">
							<el-option v-for="item in orderSourceList" :key="item.code" :label="item.name" :value="item.code" />
						</el-select>
					</el-descriptions-item>
					<el-descriptions-item label="商品数量"><span style="width: 100px; display: inline-block">{{ totalQuantity }}</span></el-descriptions-item>
					<el-descriptions-item label="商品总金额"><span style="width: 100px; display: inline-block; font-weight: bold; font-size: 16px; color: red" v-money="totalGoodsMoney">￥{{ totalGoodsMoney }}元</span></el-descriptions-item>
					<el-descriptions-item label="订单总金额"><el-input-number v-model.number="saleInfo.totalMoney" placeholder="请输入订单总金额" size="small" style="width: 100%" min="0" step="0.01" :precision="2" /></el-descriptions-item>
					<el-descriptions-item label="电话邀约人">
						<el-select v-model="saleInfo.phonePnvitation" placeholder="请选择电话邀约人" filterable size="small" style="width: 100%">
							<el-option v-for="item in userList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
						</el-select>
					</el-descriptions-item>
					<el-descriptions-item label="支付方式" span="6">
						<div class="pay-types-row">
							<div v-for="payTypeItem in saleInfo.payTypes" :key="payTypeItem.payTypeId" class="pay-type-item" :class="{ 'pay-type-item-active': payTypeItem.payMoney > 0 }">
								<span class="pay-type-label">{{ payTypeItem.payTypeName }}</span>
								<el-input-number v-model.number="payTypeItem.payMoney" placeholder="0.00" :min="0" :step="0.01" :precision="2" size="small" controls-position="right"></el-input-number>
								<el-input v-model="payTypeItem.payComment" placeholder="备注" clearable size="small"></el-input>
							</div>
						</div>
					</el-descriptions-item>

					<el-descriptions-item label="订单备注" span="4"><el-input v-model="saleInfo.remark" placeholder="请输入订单备注" type="textarea" clearable :rows="2" /></el-descriptions-item>
				</el-descriptions>
			</div>
		</div>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" icon="el-icon-close" @click="closeDialog">取消</el-button>
				<el-button size="small" type="primary" icon="el-icon-check" :loading="saveloading" class="title" @click="handleSubmitSalesOrder()">保存</el-button>
			</div>
		</template>
	</my-dialog>
</template>
<script>
import { getCustomerInfoDetail } from "@/api/baseDataApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import { SaveSalesOrder } from "@/api/productApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
import { GetCustomerVipInfoByKeyId } from "@/api/baseDataApi.js";
export default {
	props: [],
	data() {
		return {
			showDialog: false,
			saveloading: false,
			storeList: [],
			customerInfo: {
				name: "",
				phone: "",
				age: "",
				gender: -1,
				belongStoreName: "",
				lParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: 0,
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				},
				rParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: 0,
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				}
			},
			orderSourceList: [],
			saleInfo: {
				payTypes: [],
				customerKeyId: "",
				dtls: [],
				storeKeyId: "",
				totalMoney: 0,
				totalPayMoney: 0,
				orderSource: 1,
				remark: "",
				phonePnvitation: ""
			},
			userList: [],
			payTypeList: [],
			vipInfo: {},
			totalQuantity: 0,
			totalGoodsMoney: 0,
			isSubmitting: false,
			listSelectedGoods: []
		};
	},
	computed: {},
	watch: {},
	components: {},
	created() {
		this.GetOrgInfoListByConfig();
		this.getOrderSource();
		this.GetPayTypeListByCode();
	},
	methods: {
		// 显示
		showSettlementDialog(saleInfo) {
			// 清空上一次的数据
			this.resetData();
			this.GetPayTypeListByCode();
			this.showDialog = true;
			this.totalQuantity = saleInfo.totalQuantity;
			this.totalGoodsMoney = saleInfo.totalMoney;
			this.listSelectedGoods = saleInfo.listSelectedGoods;
			this.saleInfo.customerKeyId = "";
			this.saleInfo.dtls = [];
			this.saleInfo.storeKeyId = saleInfo.storeKeyId;
			this.saleInfo.totalMoney = saleInfo.totalMoney;
			this.saleInfo.totalPayMoney = 0;
			this.saleInfo.orderSource = 1;
			this.saleInfo.remark = "";
			this.saleInfo.phonePnvitation = "";
			this.saleInfo.payTypes.forEach((item) => {
				item.payMoney = 0;
				item.payComment = "";
			});
			this.GetUserBindSelectByPermission();
		},
		// 重置展示数据（打开弹窗/切换数据时清空旧内容）
		resetData() {
			this.customerInfo = {
				name: "",
				phone: "",
				age: "",
				gender: -1,
				belongStoreName: "",
				lParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: 0,
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				},
				rParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: 0,
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				}
			};
			this.vipInfo = {};
			this.totalQuantity = 0;
			this.totalGoodsMoney = 0;
			this.listSelectedGoods = [];
		},
		//获取支付类型信息
		GetPayTypeListByCode() {
			const paramer = {
				code: "PayType"
			};
			GetEnumConfigListByCode(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.payTypeList = [];
						this.saleInfo.payTypes = [];
						res.data.forEach((item) => {
							var payTypeId = parseInt(item.code);
							var payTypeName = item.name;
							this.payTypeList.push({
								payTypeId: payTypeId,
								payTypeName: payTypeName
							});
							this.saleInfo.payTypes.push({
								payTypeId: payTypeId,
								payTypeName: payTypeName,
								payMoney: 0,
								payComment: ""
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取状态信息失败!");
				});
		},
		// 获取员工列表信息
		GetUserBindSelectByPermission() {
			if (!this.saleInfo.storeKeyId) {
				this.$message.error("请选择门店！");
				return;
			}
			GetUserBindSelectByPermission({
				keyId: this.saleInfo.storeKeyId
			})
				.then((res) => {
					if (res.code == 1) {
						this.userList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取员工列表失败，请稍后再试！");
				});
		},
		// 处理提交支付
		handleSubmitSalesOrder() {
			if (!this.saleInfo.customerKeyId) {
				this.$message.error("请选择客户！");
				return;
			}
			if (!this.saleInfo.storeKeyId) {
				this.$message.error("请选择门店！");
				return;
			}
			var totalPayMoney = 0;
			var usedPayTypes = [];
			for (var i = 0; i < this.saleInfo.payTypes.length; i++) {
				var payTypeItem = this.saleInfo.payTypes[i];
				if (payTypeItem.payMoney <= 0) continue;
				if (payTypeItem.payMoney < 0) {
					this.$message.error("支付金额不能小于0！");
					return;
				}
				if (payTypeItem.payTypeId == 5) {
					if (usedPayTypes.includes(payTypeItem.payTypeId)) {
						this.$message.error("会员卡销仅能支付一笔！");
						return;
					}
					usedPayTypes.push(payTypeItem.payTypeId);
				}
				totalPayMoney += payTypeItem.payMoney;
			}
			if (totalPayMoney == 0 && this.saleInfo.orderSource !== 3 && this.saleInfo.orderSource !== 7 && this.saleInfo.orderSource !== 8) {
				this.$message.error("请输入支付金额！");
				return;
			}
			if (totalPayMoney > this.saleInfo.totalMoney) {
				this.$message.error("实际收款金额不能超过订单金额！");
				return;
			}
			this.isSubmitting = true;
			var products = [];
			this.listSelectedGoods.forEach((item) => {
				products.push({
					storeProductKeyId: item.keyId,
					quantity: item.quantity
				});
			});
			this.saleInfo.dtls = products;
			SaveSalesOrder(this.saleInfo)
				.then((res) => {
					if (res.code == 1) {
						this.$message.success("支付成功！");
						this.closeDialog();
						this.$parent.clearSelectedGoods();
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("支付失败，请稍后再试！");
				})
				.finally(() => {
					this.isSubmitting = false;
				});
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 选择门店
		handleSelectStore(val) {
			this.saleInfo.storeKeyId = val;
		},
		// 选中顾客
		submitSelect(selectionKeyId) {
			this.saleInfo.customerKeyId = selectionKeyId;
			let params = {
				keyId: selectionKeyId
			};
			getCustomerInfoDetail(params).then((res) => {
				if (res.code == 1) {
					this.customerInfo = this.normalizeCustomerInfo(res.data);

					GetCustomerVipInfoByKeyId({
						keyId: selectionKeyId
					}).then((resVip) => {
						if (resVip.code == 1) {
							this.vipInfo = resVip.data;
						} else {
							this.$message({
								type: "error",
								message: resVip.msg
							});
						}
					});
				} else {
					this.$message({
						type: "error",
						message: res.msg
					});
				}
			});
		},
		//转换性别
		transformGender(gender) {
			if (gender == 1) {
				return "男";
			} else if (gender == 0) {
				return "女";
			} else {
				return "--";
			}
		},
		// 归一化后端返回的顾客信息：lParams/rParams 可能为 null，需回填默认对象，避免模板访问 null 报错
		normalizeCustomerInfo(data) {
			const empty = {
				lParams: { qiuJing: "", zhuJing: "", zhouWei: "", jiaoZhengShiLi: "", tongJu: "", tongGao: "" },
				rParams: { qiuJing: "", zhuJing: "", zhouWei: "", jiaoZhengShiLi: "", tongJu: "", tongGao: "" }
			};
			const info = Object.assign({}, data || {});
			info.lParams = Object.assign({}, empty.lParams, (data && data.lParams) || {});
			info.rParams = Object.assign({}, empty.rParams, (data && data.rParams) || {});
			return info;
		},
		// 关闭
		closeDialog() {
			this.saleInfo = this.$options.data.call(this).saleInfo;
			this.customerInfo = {
				name: "",
				phone: "",
				age: "",
				gender: -1,
				belongStoreName: "",
				lParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: 0,
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				},
				rParams: {
					qiuJing: "",
					zhuJing: "",
					zhouWei: 0,
					jiaoZhengShiLi: "",
					tongJu: "",
					tongGao: ""
				}
			};
			this.showDialog = false;
		},
		//判断为空则用 -- 替代
		transformEmpty(obj) {
			if (obj == "" || obj == null || obj == undefined) {
				obj = "--";
			}
			return obj;
		},
		// 展示选择顾客弹窗
		showSelectCustomerDialog() {
			this.$parent.showSelectCustomerDialog();
		},
		// 获取订单来源
		getOrderSource() {
			GetEnumConfigListByCode({
				code: "StoreOrderSource"
			})
				.then((res) => {
					if (res.code == 1) {
						this.orderSourceList = [];
						res.data.forEach((item) => {
							this.orderSourceList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.$message.error("获取加工类型失败!");
				});
		},
		// 选择订单来源
		handleSelectOrderSource(val) {
			this.saleInfo.orderSource = val;
		}
	}
};
</script>
<style scoped lang="scss">
.main_bg {
	padding: 10px;
	margin-top: -15px;
}

.item_info {
	border-left: 5px solid #55aaff;
	padding: 5px 10px;
	border-radius: 5px;
	margin-bottom: 15px;
	border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
	border-left: 5px solid #ff9900;
}

.border_Green {
	border-left: 5px solid #00cc66;
}

.item_title {
	display: flex;
	width: 100%;
	font-weight: 700;
	font-size: 1rem;
	margin-bottom: 10px;
	justify-content: space-between;

	.title {
		display: inline-block;
		unicode-bidi: isolate;
	}

	.btnDiv {
		display: block;
		unicode-bidi: isolate;
		word-break: break-all;
	}
}

.pay-types-container {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.pay-types-row {
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
}

.pay-type-item {
	display: flex;
	align-items: center;
	padding: 10px 15px;
	background: #fafafa;
	border-radius: 6px;
	border: 1px solid #ebeef5;
	transition: all 0.3s ease;
	gap: 15px;
	width: calc(50% - 7.5px);
	box-sizing: border-box;

	&:hover {
		border-color: #409eff;
		background: #f0f9ff;
	}

	&-active {
		border-color: #409eff;
		background: #f0f9ff;
		box-shadow: 0 2px 8px 0 rgba(64, 158, 255, 0.15);
	}
}

.pay-type-label {
	width: 100px;
	font-weight: 600;
	color: #303133;
	font-size: 14px;
	flex-shrink: 0;
}

.pay-types-row .el-input-number {
	width: 140px;
	flex-shrink: 0;
}

.pay-types-row .el-input {
	flex: 1;
	min-width: 100px;
}
</style>
